<template>
  <div class="FramedImage">
    <div class="FramedImage__outer">
      <div class="FramedImage__inner">
        <img class="FramedImage__image" :src="src" :alt="alt" loading="lazy" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'

defineProps({
  /** Image source URL. Prefer imported asset URLs. */
  src: {
    type: String as PropType<string>,
    required: true,
  },
  /** Accessible alt text. */
  alt: {
    type: String as PropType<string>,
    default: '',
  },
})
</script>

<style lang="scss" scoped>
.FramedImage {
  height: 100%;

  .FramedImage__outer {
    height: 100%;
    padding: 0.125rem;
    border-radius: 1rem;
    border: 0.588px solid
      var(--Colors-Border-border-secondary_alt, rgba(0, 0, 0, 0.08));
    background-color: var(--Colors-Background-bg-primary, #fff);
    box-shadow:
      0 7.056px 9.407px -2.352px
        var(--Colors-Effects-Shadows-shadow-lg_01, rgba(0, 16, 53, 0.08)),
      0 2.352px 3.528px -1.176px
        var(--Colors-Effects-Shadows-shadow-lg_02, rgba(0, 16, 53, 0.03)),
      0 1.176px 1.176px -0.588px
        var(--Colors-Effects-Shadows-shadow-lg_03, rgba(0, 16, 53, 0.04));
  }

  .FramedImage__inner {
    height: 100%;
    border-radius: 1rem;
    padding: 0.125rem;
    box-shadow:
      0 0 3.528px 1.176px
        var(--Colors-Effects-Shadows-shadow-lg_01, rgba(0, 16, 53, 0.08)) inset,
      0 0 2.352px 1.176px
        var(--Colors-Effects-Shadows-shadow-lg_02, rgba(0, 16, 53, 0.03)) inset;
  }

  .FramedImage__image {
    display: block;
    height: 100%;
    width: auto;
    object-fit: contain;
    object-position: right center;
    border-radius: 1rem;
    background-color: var(--Colors-Background-bg-primary, #fff);
    border: 1.176px solid
      var(--Component-colors-Utility-Gray-utility-gray-200, #dcdfea);
  }
}
</style>
